/**
 * @generated SignedSource<<e56206d85b664992f2b43edc1a49b3ae>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateAssignmentInput = {
  classes: ReadonlyArray<CreateAssignmentClassInput>;
  dueOn: any;
  name: string;
  skillId: string;
  startedOn: any;
};
export type CreateAssignmentClassInput = {
  classId: string;
  createAssignmentInputItems: ReadonlyArray<CreateAssignmentInputItemInput>;
};
export type CreateAssignmentInputItemInput = {
  skillIds: ReadonlyArray<string>;
  userId: string;
};
export type AssignmentCreateAssignmentMutation$variables = {
  input: CreateAssignmentInput;
};
export type AssignmentCreateAssignmentMutation$data = {
  readonly createAssignment: {
    readonly assignmentNode: ReadonlyArray<{
      readonly id: string;
    }> | null | undefined;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
      readonly paramName?: string | null | undefined;
    }> | null | undefined;
  };
};
export type AssignmentCreateAssignmentMutation = {
  response: AssignmentCreateAssignmentMutation$data;
  variables: AssignmentCreateAssignmentMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "AssignmentNode",
  "kind": "LinkedField",
  "name": "assignmentNode",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
},
v4 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "paramName",
      "storageKey": null
    }
  ],
  "type": "ArgumentError",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": [
    (v3/*: any*/)
  ],
  "type": "UnauthorizedAccessError",
  "abstractKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AssignmentCreateAssignmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateAssignmentPayload",
        "kind": "LinkedField",
        "name": "createAssignment",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AssignmentCreateAssignmentMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "CreateAssignmentPayload",
        "kind": "LinkedField",
        "name": "createAssignment",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v4/*: any*/),
              (v5/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "47d92452662d62d414e134ec6ee6ba6f",
    "id": null,
    "metadata": {},
    "name": "AssignmentCreateAssignmentMutation",
    "operationKind": "mutation",
    "text": "mutation AssignmentCreateAssignmentMutation(\n  $input: CreateAssignmentInput!\n) {\n  createAssignment(input: $input) {\n    assignmentNode {\n      id\n    }\n    errors {\n      __typename\n      ... on ArgumentError {\n        message\n        paramName\n      }\n      ... on UnauthorizedAccessError {\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ade413ffa68a3e0286897fd03e4c62ad";

export default node;
